// 此文件不要动
export const nameComponentObj = {
  "productCategoryManage": {
    name: "productCategoryManage",
    label: "商品管理/分类管理",
    permissionIdentification: "product:category:list", // 权限标识
    recycleBinIdentification: "Product.Category", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "productModule" */"@/views/product/category/index.vue")
  },
  "productSkuAttrManage": {
    name: "productSkuAttrManage",
    label: "商品管理/规格属性管理",
    permissionIdentification: "product:skuAttr:list", // 权限标识
    recycleBinIdentification: "Product.SkuAttr", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "productModule" */"@/views/product/sku-attr/index.vue")
  },
  "productSkuValueManage": {
    name: "productSkuValueManage",
    label: "商品管理/规格值管理",
    permissionIdentification: "product:skuValue:list", // 权限标识
    recycleBinIdentification: "Product.SkuValue", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "productModule" */"@/views/product/sku-value/index.vue")
  },
  "productTagManage": {
    name: "productTagManage",
    label: "商品管理/标签管理",
    permissionIdentification: "product:tag:list", // 权限标识
    recycleBinIdentification: "Product.Tag", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "productModule" */"@/views/product/tag/index.vue")
  },
  "productBrandManage": {
    name: "productBrandManage",
    label: "商品管理/品牌管理",
    permissionIdentification: "product:brand:list", // 权限标识
    recycleBinIdentification: "Product.Brand", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "productModule" */"@/views/product/brand/index.vue")
  },
  "productGoodsManage": {
    name: "productGoodsManage",
    label: "商品管理/商品列表",
    permissionIdentification: "product:goods:list", // 权限标识
    recycleBinIdentification: "Product.Goods", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "productModule" */"@/views/product/goods/index.vue")
  },
  "productPublishGoods": {
    name: "productPublishGoods",
    label: "商品管理/发布商品",
    permissionIdentification: "product:goods:create:update:read", // 权限标识
    component: () => import(/* webpackChunkName: "productModule" */"@/views/product/goods/publish.vue")
  }
}

// 没有按钮权限标识数据 也要暴露一个对象出去
export const btnObj = {
  productCategoryCreate: {
    label: "商品管理/分类管理/新增分类",
    value: "product:category:create"
  },
  productCategoryDelete: {
    label: "商品管理/分类管理/删除分类",
    value: "product:category:delete"
  },
  productCategoryUpdate: {
    label: "商品管理/分类管理/更新分类",
    value: "product:category:update"
  },
  productCategoryRead: {
    label: "商品管理/分类管理/查看分类",
    value: "product:category:read"
  },
  productCategoryStatus: {
    label: "商品管理/分类管理/修改状态",
    value: "product:category:status"
  },
  productCategoryParams: {
    label: "商品管理/分类管理/参数配置",
    value: "product:category:params"
  },
  productCategorySku: {
    label: "商品管理/分类管理/规格配置",
    value: "product:category:skuAttr"
  },
  productCategoryBrand: {
    label: "商品管理/分类管理/品牌配置",
    value: "product:category:brand"
  },
  productSkuAttrCreate: {
    label: "商品管理/规格属性管理/新增规格属性",
    value: "product:skuAttr:create"
  },
  productSkuAttrDelete: {
    label: "商品管理/规格属性管理/删除规格属性",
    value: "product:skuAttr:delete"
  },
  productSkuAttrUpdate: {
    label: "商品管理/规格属性管理/更新规格属性",
    value: "product:skuAttr:update"
  },
  productSkuAttrRead: {
    label: "商品管理/规格属性管理/查看规格属性",
    value: "product:skuAttr:read"
  },
  productSkuAttrStatus: {
    label: "商品管理/规格属性管理/修改状态",
    value: "product:skuAttr:status"
  },
  productSkuValueCreate: {
    label: "商品管理/规格值管理/新增规格值",
    value: "product:skuValue:create"
  },
  productSkuValueDelete: {
    label: "商品管理/规格值管理/删除规格值",
    value: "product:skuValue:delete"
  },
  productSkuValueUpdate: {
    label: "商品管理/规格值管理/更新规格值",
    value: "product:skuValue:update"
  },
  productSkuValueRead: {
    label: "商品管理/规格值管理/查看规格值",
    value: "product:skuValue:read"
  },
  productSkuValueStatus: {
    label: "商品管理/规格值管理/修改状态",
    value: "product:skuValue:status"
  },
  productTagCreate: {
    label: "商品管理/标签管理/新增标签",
    value: "product:tag:create"
  },
  productTagDelete: {
    label: "商品管理/标签管理/删除标签",
    value: "product:tag:delete"
  },
  productTagUpdate: {
    label: "商品管理/标签管理/更新标签",
    value: "product:tag:update"
  },
  productTagRead: {
    label: "商品管理/标签管理/查看标签",
    value: "product:tag:read"
  },
  productTagStatus: {
    label: "商品管理/标签管理/修改状态",
    value: "product:tag:status"
  },
  productBrandCreate: {
    label: "商品管理/品牌管理/新增品牌",
    value: "product:brand:create"
  },
  productBrandDelete: {
    label: "商品管理/品牌管理/删除品牌",
    value: "product:brand:delete"
  },
  productBrandUpdate: {
    label: "商品管理/品牌管理/更新品牌",
    value: "product:brand:update"
  },
  productBrandRead: {
    label: "商品管理/品牌管理/查看品牌",
    value: "product:brand:read"
  },
  productBrandStatus: {
    label: "商品管理/品牌管理/修改状态",
    value: "product:brand:status"
  },
  productGoodsDelete: {
    label: "商品管理/商品列表/删除商品",
    value: "product:goods:delete"
  },
  productGoodsTag: {
    label: "商品管理/商品列表/分配标签",
    value: "product:goods:tag"
  },
  productGoodsStatus: {
    label: "商品管理/商品列表/上架、下架",
    value: "product:goods:status"
  }
}